import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/shoppingCartActions';
import Product from './CartProduct';
import Loading from './Loading';
import CheckoutCta from './CheckoutCta';
import ItemCarousel from './ItemCarousel';
import SavedItems from './SavedItems';
import PreviouslyPurchasedItems from './PreviouslyPurchasedItems';
import {formatCurrency} from '../utils/currency';
import {formatNumber} from '../utils/number';
import format from 'date-fns/format';
import {attemptAddToCart} from '../utils/orderHandling';

class ShoppingCart extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.handleItemDelete = this.handleItemDelete.bind(this);
    this.handleItemSaveForLater = this.handleItemSaveForLater.bind(this);
    this.handleSavedItemsDelete = this.handleSavedItemsDelete.bind(this);
    this.handleSavedItemsMoveToCart = this.handleSavedItemsMoveToCart.bind(this);
    this.handleSavedItemsMoveToMyProducts = this.handleSavedItemsMoveToMyProducts.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }
  componentDidMount() {
    this.fetchItems();
  }

  fetchItems() {
    this.props.actions.fetchCartItems();
    this.props.actions.fetchPreviouslyPurchasedItems();
    this.props.actions.fetchRelatedInkItems();
    this.props.actions.fetchRelatedMaintenanceItems();
    this.props.actions.fetchSavedItems();
  }

  handleQtyChange(id, qty) {
    this.props.actions.updateCartItemQty(id, qty);
  }

  handleItemDelete(id) {
    const product = this.props.shoppingCart.items.find(item => item.id == id);

    window.trackAnalytics({
      event: 'remove_from_cart',
      currency: 'USD',
      value: (product.salePrice || product.price) * product.qty,
      items: [{
        item_id: id,
        item_name: product.name,
        price: product.salePrice || product.price,
        quantity: product.qty,
      }]
    });
    this.props.actions.updateCartItemQty(id, 0);
  }

  handleSavedItemsDelete(id) {
    this.props.actions.removeFromSavedCart(id);
  }

  handleSavedItemsMoveToCart(product) {
    this.handleAddToCart(product);
  }

  handleAddToCart(product) {
    const productToAdd = Object.assign({}, product, { qty: 1 });
    attemptAddToCart([productToAdd]).then(isAdded => {
      if (isAdded) {
        if (window.$) {
          $('.shopping-cart .slick-initialized').removeClass('slick-initialized');
        }

        this.props.actions.removeFromSavedCart(product.id);
        this.props.actions.fetchCartItems();
      }
    });
  }

  handleSavedItemsMoveToMyProducts(id) {
    this.props.actions.addToMyProducts(id);
  }

  handleItemSaveForLater(id) {
    // remove from cart
    this.handleItemDelete(id);

    // add to saved list
    this.props.actions.addToSavedCart(id);
  }

  render() {
    const shoppingCart = this.props.shoppingCart;

    if (this.props.isFetchingCartItems) {
      return (<Loading/>);
    }

    // update header cart (if available)
    if (window.updateHeaderCartStatus) {
      window.updateHeaderCartStatus(`${shoppingCart.total > 99 ? '99+' : formatNumber(shoppingCart.total)} ${shoppingCart.total === 1 ? 'item' : 'items'} (${formatCurrency(shoppingCart.subtotal)})`);
    }

    return (

      <div>
        <CheckoutCta total={shoppingCart.total}
                     subtotal={shoppingCart.subtotal}
                     isFreeShipping={shoppingCart.isFreeShipping}
                     className="hide-for-medium"/>

        <div className="row shopping-cart__top">
          <div className="small-12 medium-8 columns">

            {

              shoppingCart.total ?

                <div>

                  <div className="shopping-cart__headers">
                    <div className="row">
                      <div className="small-8 columns shopping-cart__headers__item">
                        <h1>Shopping Cart</h1>
                      </div>
                      <div className="small-2 columns shopping-cart__headers__item -small">
                        Price
                      </div>
                      <div className="small-2 columns shopping-cart__headers__item -small">
                        Quantity
                      </div>
                    </div>
                  </div>

                  <div className="shopping-cart__list">
                    {shoppingCart.items.map(product =>
                      <Product key={product.id}
                               product={product}
                               onQtyChange={this.handleQtyChange}
                               onDelete={this.handleItemDelete}
                               onSaveForLater={this.handleItemSaveForLater}/>
                    )}
                  </div>

                  <h3 className="shopping-cart__subtotal">
                    <span className="shopping-cart__subtotal__label">Subtotal ({formatNumber(shoppingCart.total)} {shoppingCart.total === 1 ? 'item' : 'items'}):</span>
                    <span className="shopping-cart__subtotal__amount">{formatCurrency(shoppingCart.subtotal)}</span>
                  </h3>

                </div>

              :

                <div className="callout alert">
                  Your shopping cart is currently empty.
                </div>

            }

            <SavedItems items={this.props.savedItems}
                        isFetching={this.props.isFetchingSavedItems}
                        onDelete={this.handleSavedItemsDelete}
                        onMoveToCart={this.handleSavedItemsMoveToCart}
                        onMoveToYourProducts={this.handleSavedItemsMoveToMyProducts}/>

            <p className="shopping-cart__terms">The price and availability of items are subject to change. The cart is a temporary place to store a
              list of your items and reflects each item’s most recent price and stock status.<br/>
              Do you have a coupon code? We’ll ask you to enter your code when it’s time to pay.</p>

            <ItemCarousel title="Ink & toner related to items in your cart"
                          items={this.props.relatedInkItems}
                          isFetching={this.props.isFetchingRelatedInkItems}
                          onAddToCart={this.handleAddToCart}
                          isSmall={true}/>


          </div>
          <div className="small-12 medium-4 columns">
            <CheckoutCta total={shoppingCart.total}
                         subtotal={shoppingCart.subtotal}
                         isFreeShipping={shoppingCart.isFreeShipping}
                         className="show-for-medium"/>

            <PreviouslyPurchasedItems items={this.props.previouslyPurchasedItems}
                                      isFetching={this.props.isFetchingPreviouslyPurchasedItems}
                                      onAddToCart={this.handleAddToCart}/>
          </div>

        </div>

        <div className="row column">
          <ItemCarousel title="Maintenance items & parts related to items in your cart"
                        isFetching={this.props.isFetchingRelatedMaintenanceItems}
                        items={this.props.relatedMaintenanceItems}
                        onAddToCart={this.handleAddToCart}/>
        </div>
      </div>

    );
  }
}

ShoppingCart.propTypes = {
  actions: PropTypes.object.isRequired,
  shoppingCart: PropTypes.object.isRequired,
  isFetchingRelatedInkItems: PropTypes.bool.isRequired,
  isFetchingRelatedMaintenanceItems: PropTypes.bool.isRequired,
  isFetchingPreviouslyPurchasedItems: PropTypes.bool.isRequired,
  isFetchingSavedItems: PropTypes.bool.isRequired,
  relatedInkItems: PropTypes.array.isRequired,
  relatedMaintenanceItems: PropTypes.array.isRequired,
  previouslyPurchasedItems: PropTypes.array.isRequired,
  savedItems: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    isFetchingCartItems: state.shoppingCart.isFetching,
    isFetchingRelatedInkItems: state.shoppingCart.isFetchingRelatedInkItems,
    isFetchingRelatedMaintenanceItems: state.shoppingCart.isFetchingRelatedMaintenanceItems,
    isFetchingPreviouslyPurchasedItems: state.shoppingCart.isFetchingPreviouslyPurchasedItems,
    isFetchingSavedItems: state.shoppingCart.isFetchingSavedItems,
    shoppingCart: state.shoppingCart.shoppingCart,
    relatedInkItems: state.shoppingCart.relatedInkItems,
    relatedMaintenanceItems: state.shoppingCart.relatedMaintenanceItems,
    previouslyPurchasedItems: state.shoppingCart.previouslyPurchasedItems,
    savedItems: state.shoppingCart.savedItems,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShoppingCart);
